export const OrganizationType = {
  SurgeryCenter: 'SurgeryCenter',
  SurgeonOffice: 'SurgeonOffice',
};
